import { useDrag } from 'react-dnd';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
/**
 * DraggableBox component allows a box element to be draggable in a drag-and-drop context.
 *
 * @param column string The column identifier for the dragged item
 * @param type string The type of the draggable item (used to define drag-and-drop behavior)
 * @param index number The index of the item in the list or grid, to track its position
 * @param children ReactNode The content of the box, usually other components or text
 * @param className string CSS class name for styling the box
 * @param selected boolean A flag indicating whether the item is selected
 * @param check boolean A flag that can be used to check certain conditions for the item
 *
 * @returns {JSX.Element} A draggable box element
 */
const DraggableBox = ({ column, type, index, children, className, selected, check, onClick }) => {
    const [{ isDragging }, drag] = useDrag({
        type,
        item: { column, index, selected, check },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    });

    return (
        <div ref={drag} className={className} onClick={onClick}>
            {children}
        </div>
    );
};

export default DraggableBox;
